export default {
  getCurrentSystemBalance() {
    return axios
      .get(
        `${ import.meta.env.VITE_SITE_URL }/crms/system-balances/current`,
      );
  },
};
